export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores-municipio',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.indicadores.municipio.list',
    meta: {
      requiresAuth: true
    }
  }
]
